import { axios } from "@/services/axios";
import { merge, has, extend } from "lodash";
import { currentUser } from "@/services/auth";

// Normalize condition operators for backwards compatibility
const normalizeCondition = {
  "greater than": ">",
  "less than": "<",
  equals: "=",
};

const transformResponse = data =>
  merge({}, data, {
    options: {
      op: normalizeCondition[data.options.op] || data.options.op,
    },
    query: data.query || {},
    data_source: data.data_source || {},
    tags: data.tags || [],
    user: data.user || currentUser,
  });

const transformRequest = data => {
  const newData = Object.assign({}, data);
  if (newData.query_id === undefined) {
    newData.query_id = newData.query.id;
    newData.data_source_id = newData.data_source.id;
    delete newData.query;
    delete newData.data_source;
    delete newData.is_favorite;
  }
  
  return newData;
};

export class Indexer {
  constructor(indexer) {
    extend(this, indexer);

    if (!has(this, "options")) {
      this.options = {};
    }
    if (!has(this, "query")) {
      this.query = {};
    }
    if (!has(this, "data_source")) {
      this.data_source = {};
    }
    if (!has(this, "tags")) {
      this.tags = [];
    }
    if (!has(this, "user")) {
      this.user = currentUser;
    }
  }

  isNew() {
    return this.id === undefined;
  }

  getUrl() {
    return `indexers/${this.id}`;
  }

  favorite() {
    return Indexer.favorite(this.id);
  }

  unfavorite() {
    return Indexer.unfavorite(this.id);
  }
}

const saveOrCreateUrl = data => (data.id ? `api/indexers/${data.id}` : "api/indexers");

const IndexerService = {
  query: params => axios.get("api/indexers", { params }),
  get: ({ id }) => axios.get(`api/indexers/${id}`).then(transformResponse),
  delete: id => axios.delete(`api/indexers/${id}`),
  recent: params => axios.get("api/indexers/recent", { params }),
  archive: params => axios.get("api/indexers/archive", { params }),
  myIndexers: params => axios.get("api/indexers/my", { params }),
  favorites: params => axios.get("api/indexers/favorites", { params }),
  favorite: id => axios.post(`api/indexers/${id}/favorite`),
  unfavorite: id => axios.delete(`api/indexers/${id}/favorite`),
  run: id => axios.post(`api/indexers/${id}/run`),
  status: id => axios.get(`api/indexers/${id}/status`),
};

IndexerService.save = data => axios.post(saveOrCreateUrl(data), transformRequest(data)).then(transformResponse);

IndexerService.newIndexer = function newIndexer() {
  return new Indexer({
    name: "New Indexer",
    query: null,
    data_source: null,
    options: {
      target_table: "",
      delete_duplicates: false,
      data_source_id: null,
      insert_strategy: "append",
    },
    user: currentUser,
    tags: [],
    can_edit: true,
  });
};

extend(Indexer, IndexerService);

export default Indexer;
